import { COMPLAINTS_STORE_SEARCH } from "../actions";
const initialState = {};
// This reducer keeps the state of the query on a given page so e.g. you can drill into a case from a filtered dashboard,
//  and then return to the dashboard page retaining the filter/sort/page that you left with
export const urlSearch = (state = initialState, { type, payload }) => {
    if (type !== COMPLAINTS_STORE_SEARCH) {
        return state;
    }
    const { pathname, search } = payload;
    return Object.assign(Object.assign({}, state), { [pathname]: search });
};
